<template>
  <surveys-grid :type="2" :items="surveys" :page-title="pageTitle" @refresh="refresh"
                return-page="surveys"
                :empty-text="$t('No quizzes or surveys')"
                extended-buttons/>
</template>

<script>
import {mapActions, mapState} from "vuex";
import PageTitle from "@/mixins/pageTitle";
import BeforeRoute from "@/mixins/beforeRoute";
import SurveysGrid from "@/components/quiz/SurveysGrid";

export default {
  name: "SurveysPage",
  components: {SurveysGrid},
  mixins: [
    BeforeRoute('fetchSurveys'),
    PageTitle('Quizy i ankiety'),
  ],
  methods: {
    ...mapActions([
      'fetchUser',
      'fetchSurveys'
    ]),
    refresh() {
      this.fetchSurveys();
      this.fetchUser();
    },
  },
  computed: {
    ...mapState({
      surveys: state => state.surveys.surveys,
    }),
  }
}
</script>

<style scoped>

</style>
